import { useState } from 'react';
import { useAuth } from '../auth/auth-provider';
import { translate } from '../firebase/errors';
import { toast } from 'react-toastify';
import * as Sentry from "@sentry/react";

function EditProfileModal({ onClose }) {
  const { user, updateUserProfile } = useAuth();
  const [formData, setFormData] = useState({displayName: user.displayName});
  const [error, setError] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleUpdateUserProfile();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleUpdateUserProfile = async () => {
    try {
      await updateUserProfile(formData);
      setFormData({displayName: user.displayName});
      toast('Profile updated successfully', { type: 'success', autoClose: 2000 });
      onClose();
    }
    catch (e) {
      const { code } = e;
      const message = code ? translate(code) : e.message;
      setError(message || `An error has occurred: ${code}`);
      if (!message) {
        Sentry.captureException(e);
      }
    }
  };

  return (
    <div className="modal is-active" onKeyDown={handleKeyDown}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Edit Profile</p>
        </header>
        <section className="modal-card-body">
          {error && <div className="notification is-danger is-light">{error}</div>}
          <div className="field">
            <div className="control">
              <input className="input" type="text" name="displayName" value={formData.displayName || ''} placeholder="Display Name" onChange={handleChange} autoFocus/>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot">
          <button className="button" onClick={onClose}>Cancel</button>
          <button className="button is-primary" onClick={handleUpdateUserProfile}>Save</button>
        </footer>
      </div>
    </div>
  );
}

export default EditProfileModal;
